// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__33uHg","author":"Table_author__3mBht","authorImage":"Table_authorImage__2mjbp","unreadRow":"Table_unreadRow__29TI_"};